import Vue from 'vue';
import ABaseComponent from 'Components/Base/ABaseComponent';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { Client, InvoiceViewModel,IPostedOrder, PendingOrderViewModel } from 'Api/CoreApi';
import ApiProvider from 'Api/ApiProvider';

@Component({})
export default class OrdersPendingComponent extends ABaseComponent {

    orders: PendingOrderViewModel[] = [];

    search: string = '';


    get locations() {
        let result: { [customerName: string]: PendingOrderViewModel[] } = {}
        if (this.orders) {
            this.orders.forEach(order => {
                let key = order.postedOrder.extraInfo["SellToCustomerName"];
                let orders = result[key];
                if (!orders) {
                    result[key] = orders = [];
                }
                orders.push(order);
            });
        }
        return result;
    }

    @Watch('search')
    async onSearchChanged() {
        this.load();
    }

    async created() {
        await this.load();
    }

    async load() {
        this.setLoading();
        try {
            const client = ApiProvider.getApiClient();
            let ordersResult = await client.getPendingOrders();
            this.orders = ordersResult.orders;
            this.setLoaded();
        } catch (e) {
            this.setError(e);
        }
    }

}

Vue.component('orders-pending', OrdersPendingComponent);
